import(/* webpackMode: "eager" */ "/codebuild/output/src3079947011/src/helloero-new/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3079947011/src/helloero-new/node_modules/next/dist/client/link.js");
